import { ChangeEventHandler, FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import presetRecipients from 'constants/presetRecipients';
import { isPlatformAXA } from 'utils/showDetails';

type RecipientEmail = {
  name: string;
  email: string;
};

type SendEmailAddressesProps = {
  to: string | RecipientEmail[];
  presetGroup: string;
  onChangeTo: ChangeEventHandler<HTMLInputElement>;
};

const SendEmailAddresses: FC<SendEmailAddressesProps> = ({
  to,
  presetGroup,
  onChangeTo,
}) => {
  const { t } = useTranslate();

  const isCustomPreset = presetGroup === presetRecipients.CUSTOM;
  const isReadOnly = presetGroup === '' || !isCustomPreset || isPlatformAXA;

  // Backward compatible: non-AXA uses array for presets (PARTNERS, etc.) and
  // string for CUSTOM (user types emails). AXA CUSTOM can pass array (partner/category).
  const displayValue = Array.isArray(to)
    ? (to as RecipientEmail[]).map((item) => item.email).join(', ')
    : (to as string) ?? '';

  return (
    <div className="nk-reply-form-header">
      <div className="nk-reply-form-group">
        <div className="nk-reply-form-input-group">
          <div className="nk-reply-form-input nk-reply-form-input-to">
            <label className="label" style={{ width: '25px' }}>
              {t('EmailTo')}:
            </label>
            <input
              type="text"
              className="input-mail tagify ml-1"
              value={displayValue}
              onChange={onChangeTo}
              readOnly={isReadOnly}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SendEmailAddresses;
